export default __webpack_public_path__ + "static/media/login-lock.26ac6da4.svg";